module.exports = __webpack_public_path__ + "static/media/hightlight.a27c32c2.png";